import React from 'react';
import './bio.css'
import Imagen1 from '../../images/bio/7F5A6823.jpg'
import Imagen2 from '../../images/bio/STLDUO1_ZIPPO.jpg'
import { Fade } from "react-awesome-reveal";

function Bio() {
    return (
        <section className='biowrapper' id='bio'>
            <div className='parte1'>
                <div className='biofoto1'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen1} className='img1es' alt="" />
                    </Fade>
                </div>
                <div className='biotexto'>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <h2>IRMGARD AMY MÜNCHGESANG</h2>
                    </Fade>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <p>
                Bratschistin und Sängerin
Sie spezialisierte sich auf Tangomusik im Orquesta Escuela Municipal de Tango (Rosario) unter der
Leitung von Javier Martínez Lo Re und war Mitglied renommierter Ensembles wie Conjunto Sextango
von Omar Torres, Orquesta Carlos Quilici und der Orquesta de Señoritas. Mit mehreren dieser Gruppen
unternahm sie Konzertreisen nach Europa, sowohl als Musikerin als auch als Produzentin.Neben ihrer
Tätigkeit als Interpretin wirkte sie auch als Arrangeurin, Komponistin und Studiomusikerin in
Projekten verschiedener Musikstile innerhalb der argentinischen Musikszene mit.Sie ist feministische
Aktivistin und Mitglied des Colectivo de Mujeres Tangueras Rosario, das sich für mehr
Gleichberechtigung im Tango einsetzt.Derzeit ist sie Bratschistin im Orquesta Sinfónica Provincial de
Rosario und unterrichtet in verschiedenen Einrichtungen. Zurzeit arbeitet sie an ihrem ersten
Soloalbum.
                </p>
                <br />
                <p className='photographer'>Photo by Eriola Postoli</p>
                    </Fade>
                </div>
            </div>
            <div className="parte2">
                
                <div className='biotexto'>
                <Fade bottom duration={1500} delay={100} fraction={0.3}>
                <p>
            In Deutschland geboren und in Argentinien ansässig, erlente sie das Bratschenspiel in Deutschland und
vervollständigte ihre Ausbildung in Nijmegen (Niederlande). Sie ist Absolventin der Kreativen
Therapie/ Musiktherapie

                    </p>
                    <br />
                    <p className='photographer'>Photo by Zippo Zimmermann</p>
                </Fade>

                </div>
                <div className='biofoto2'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen2} className='img2es' alt="" />

                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Bio